import { memo } from 'react';
import styled from 'styled-components';
import { SELECTABLE_BUTTON_MAX_WIDTH, DROPDOWN_ITEM_DEFAULT_HEIGHT } from 'HubStyleTokens/sizes';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import { getFromNumberDescription } from 'calling-ui-library/utils/phoneNumberSourceUtils';
import { WEB_FONT_REGULAR_WEIGHT } from 'HubStyleTokens/misc';
import { BASE_FONT_COLOR } from 'HubStyleTokens/theme';
// @ts-expect-error module is not typed
import DropdownMenuOption from 'UIComponents/dropdown/internal/DropdownMenuOption';
import UIList from 'UIComponents/list/UIList';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import Small from 'UIComponents/elements/Small';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledUIList = styled(UIList).withConfig({
  displayName: "PhoneFromNumberOptionsWorkspace__StyledUIList",
  componentId: "sc-11011i1-0"
})(["overflow-y:auto;max-height:calc((5 + 0.5) * ", ");"], DROPDOWN_ITEM_DEFAULT_HEIGHT);
const StyledDropdownMenuOption = styled(DropdownMenuOption).withConfig({
  displayName: "PhoneFromNumberOptionsWorkspace__StyledDropdownMenuOption",
  componentId: "sc-11011i1-1"
})(["width:100%;cursor:pointer;&&{min-width:", ";color:", ";font-weight:", ";}&&:hover{color:", ";text-decoration:none;}&:hover{background-color:", ";}"], SELECTABLE_BUTTON_MAX_WIDTH, BASE_FONT_COLOR, WEB_FONT_REGULAR_WEIGHT, BASE_FONT_COLOR, CALYPSO_LIGHT);
function PhoneFromNumberOptionsWorkspace({
  appIdentifier,
  channelAssignedPhoneNumbers,
  selectedFromNumber,
  onSelect
}) {
  return /*#__PURE__*/_jsx(StyledUIList, {
    children: channelAssignedPhoneNumbers.map(fromNumberOption => {
      let Message = {};
      const fromNumberString = fromNumberOption.get('friendlyName') || '';
      const fromNumberValue = fromNumberOption.phoneNumber || '';
      const fromNumberExtension = fromNumberOption.extension || '';
      const selected = fromNumberString === getIn(['friendlyName'], selectedFromNumber);
      Message = fromNumberOption.nickname ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: fromNumberOption.nickname
        }), /*#__PURE__*/_jsxs(Small, {
          className: "display-block",
          children: [/*#__PURE__*/_jsx(FormattedPhoneNumber, {
            value: fromNumberValue,
            extension: fromNumberExtension
          }), ' ', "(", getFromNumberDescription(fromNumberOption.source), ")"]
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: fromNumberValue,
          extension: fromNumberExtension
        })
      });
      return /*#__PURE__*/_jsx(StyledDropdownMenuOption, {
        selected: selected,
        onClick: () => onSelect(fromNumberOption),
        "data-selenium-test": `pre-call-option-${fromNumberOption.phoneNumber}-${appIdentifier}`,
        children: Message
      }, fromNumberOption.phoneNumber);
    })
  });
}
export default /*#__PURE__*/memo(PhoneFromNumberOptionsWorkspace);